import { i18n } from '@/core/setup/i18n';

export const getBundles = async ({ commit, dispatch }) => {
  commit('setLoading', true);
  commit('bundles/set', {
    path: 'isFetchingBundles',
    value: true,
  });

  try {
    await dispatch('netGetRequest', { url: '/bundle/list' }).then(function (response) {
      commit('bundles/set', { path: 'allBundles', value: response.data });
    });
  } finally {
    commit('bundles/set', {
      path: 'isFetchingBundles',
      value: false,
    });
    commit('setLoading', false);
  }
};

export const storeBundle = async (
  { commit, dispatch },
  bundle,
) => {
  let { _imageBlob, ...bundleToSave } = bundle;
  if (_imageBlob) {
    bundleToSave = { ...bundleToSave, image: _imageBlob };
  }

  commit('setLoading', true);

  try {
    const bundle = await dispatch('netPostRequest', { url: '/bundle/store', data: bundleToSave }).then(response => {
      dispatch('insertEntities', { name: 'Bundle', payload: bundle });
      return response.data;
    }).catch(error => {
      throw error;
    });
    return bundle;
  } finally {
    commit('setLoading', false);
  }
};

export const getBundle = async (
  { commit, dispatch },
  bundleId,
) => {
  commit('setLoading', true);
  commit('bundles/set', {
    path: 'isFetchingBundle',
    value: true,
  });

  try {
    const bundle = await dispatch('netGetRequest', { url: `/bundle/get/${bundleId}` }).then(function (response) {
      // TODO Erik: Don't store in state, because of SetupContents warning that state is being changed outside a mutation. Should be fixed...
      // dispatch('insertEntities', { name: 'Bundle', payload: response.data });
      return response.data;
    }).catch(function (error) {
      throw error;
    });
    return bundle;
  } finally {
    commit('setLoading', false);
    commit('bundles/set', {
      path: 'isFetchingBundle',
      value: false,
    });
  }
};

export const activeBundlesByContentOwnership = async (
  { commit, dispatch },
  contentOwnershipId,
) => {
  const result = await dispatch('netGetRequest', { url: `/bundle/active-bundles-by-content-ownership/${contentOwnershipId}` }).then(function (response) {
    return response.data;
  }).catch(error => {
    commit('setFlash', { type: 'error', message: i18n.t('An error occurred: {error} Please contact our support team.', { error: error.message }) });
    return false;
  });

  return result;
};
